// Ключи и громкость музыкальных треков. Единый источник для BootScene
// (load.audio) и MusicManager (play). Звуковые эффекты (выстрелы и т.п.)
// в этот файл НЕ ходят — они грузятся напрямую в BootScene под свои ключи.

// Многоформатная загрузка: ogg для Chromium/Firefox/Android, m4a — фолбэк
// для iOS Safari/Telegram Mini App webview (там ogg не декодируется). Phaser
// выбирает первый поддерживаемый формат из массива.
export const MUSIC_SOURCES: Record<string, string[]> = {
  music_menu: ['assets/music/music_menu.ogg', 'assets/music/music_menu.m4a'],
  music_combat: ['assets/music/music_combat.ogg', 'assets/music/music_combat.m4a'],
};

// SFX: те же правила формата (ogg + m4a фолбэк). hit_body_2 — второй вариант
// звука попадания (резерв для будущего random-выбора между двумя ударами;
// пока в коде дёргается только hit_body).
export const SFX_SOURCES: Record<string, string[]> = {
  pistol_shot: ['assets/sounds/pistol_shot.ogg', 'assets/sounds/pistol_shot.m4a'],
  hit_body: ['assets/sounds/hit_body.ogg', 'assets/sounds/hit_body.m4a'],
  hit_body_2: ['assets/sounds/hit_body_2.ogg', 'assets/sounds/hit_body_2.m4a'],
  enemy_death: ['assets/sounds/enemy_death.ogg', 'assets/sounds/enemy_death.m4a'],
  enemy_breach: ['assets/sounds/enemy_breach.ogg', 'assets/sounds/enemy_breach.m4a'],
  wave_start: ['assets/sounds/wave_start.ogg', 'assets/sounds/wave_start.m4a'],
  wave_end: ['assets/sounds/wave_end.ogg', 'assets/sounds/wave_end.m4a'],
  game_over: ['assets/sounds/game_over.ogg', 'assets/sounds/game_over.m4a'],
  defense_low: ['assets/sounds/defense_low.ogg', 'assets/sounds/defense_low.m4a'],
  defense_critical: ['assets/sounds/defense_critical.ogg', 'assets/sounds/defense_critical.m4a'],
};

// Симвоические имена треков. Используются в MusicManager и тестах.
export const MUSIC_TRACK_KEYS = {
  menu: 'music_menu',
  combat: 'music_combat',
} as const;

export type MusicTrackKey = (typeof MUSIC_TRACK_KEYS)[keyof typeof MUSIC_TRACK_KEYS];

// Общая громкость музыки. 0.4 — фон не глушит SFX (стрельбу, попадания),
// слышен достаточно для атмосферы. Подкручивай через MusicManager.setMusicVolume.
export const MUSIC_VOLUME = 0.4;
